import { ITemplateBaseDetails } from '../../../../../lib/types';
import { Button } from '../../../../_core/button/button.component';
import { useConfirm } from '../../../../_core/confirm/confirm.utils';
import { ITableMultiselectActionProps } from '../../../../_core/table/table.types';
import { useDeleteTemplateAction } from './template-table-delete-action';
import { useRestoreTemplateAction } from './template-table-restore-action';

interface ITemplateTableMultiselectActionButtonProps extends ITableMultiselectActionProps<ITemplateBaseDetails> {
  selected: boolean[];
}

export const TemplateTableMultiselectActionButton: React.FC<ITemplateTableMultiselectActionButtonProps> = ({
  selected,
  ...actionProps
}) => {
  const archiveTemplateAction = useDeleteTemplateAction(actionProps);
  const deleteTemplateAction = useDeleteTemplateAction({ ...actionProps, permanent: true });
  const restoreTemplateAction = useRestoreTemplateAction(actionProps);

  const { ConfirmationDialog: PermanentlyDeleteConfirmationDialog, confirm: confirmPermanent } = useConfirm({
    title: 'Are you sure you want to permanently delete the selected templates?',
    message: 'This action cannot be undone. Consider archiving instead.'
  });

  return (
    <>
      <Button
        disabled={!selected.some((s) => s)}
        dropdown={{
          options: [
            restoreTemplateAction,
            archiveTemplateAction,
            {
              ...deleteTemplateAction,
              onClick: (e) =>
                confirmPermanent().then((confirmed) => {
                  if (confirmed) return deleteTemplateAction.onClick?.(e);
                })
            }
          ]
        }}
        text="ACTION"
        size="large"
      />
      <PermanentlyDeleteConfirmationDialog />
    </>
  );
};
